import notificationsStore from '@store/notificationsStore';
import {IEmployeeNotification} from '@source/api/models/notificationModels';
import { InAppNotificationSocketEnum } from '@source/utils/enums';
import { useEffect, useRef } from 'react';
import io, { Socket } from "socket.io-client";
import { URL } from '@source/hooks/useSocketHome';

interface InAppNotificationSocketData {
  count?: number;
  notification?: IEmployeeNotification;
}

export default function useSocketInAppNotifications(): [() => void] {
  const socketRef = useRef<Socket | null>(null)

  useEffect(() => {
    socketRef.current = io(URL as string, { path: "/api/websocket/in-app-notifications", auth: {
      token: `Bearer ${localStorage.getItem('accessToken')}`
    }});

    socketRef.current.onAny((event: InAppNotificationSocketEnum, data: InAppNotificationSocketData) => {
      if (event === InAppNotificationSocketEnum.SUCCESSFULLY_CONNECT && typeof data?.count === 'number') {
        notificationsStore.setUnreadCount(data.count);
      }

      if (event === InAppNotificationSocketEnum.NEW_NOTIFICATION) {
        notificationsStore.receiveLiveNotification(data?.notification, data?.count);
      }
    });

    socketRef.current.on(InAppNotificationSocketEnum.ERROR, (data) => { console.log('error', data) });

    return () => {
      socketRef.current?.disconnect()
    }
  }, [])

  const onInAppNotifications = () => {
    socketRef.current?.emit(InAppNotificationSocketEnum.CONNECT)
  }

  return [onInAppNotifications];
}
